import { c as _c } from "react/compiler-runtime";
import type { UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { queryOptions, skipToken, useQuery, useQueryClient } from '@tanstack/react-query';
import type { AutoshipCustomerApiResponse } from '@libs/common-types';
import { useUserSession } from '../../hooks/useUserSession';
import { getCustomerUuid } from '../../utils/getCustomerUuid';
import { fetchAutoshipSubscriptions } from './fetchAutoshipSubscriptions';
const QUERY_KEY = 'autoship-customer-subscriptions';
const ONE_HOUR = 60 * 60 * 1000;
export type AutoshipSubscriptionsQueryOptions = Pick<UseQueryOptions<AutoshipCustomerApiResponse>, 'refetchOnMount' | 'staleTime'>;
export const autoshipSubscriptionsQueryFactory = (customerUuid?: string, options?: AutoshipSubscriptionsQueryOptions) => {
  const {
    staleTime = ONE_HOUR,
    ...queryOptionsOverrides
  } = options ?? {};
  return queryOptions({
    ...queryOptionsOverrides,
    staleTime,
    queryKey: [QUERY_KEY, customerUuid],
    queryFn: customerUuid ? fetchAutoshipSubscriptions : skipToken
  });
};
export const useAutoshipSubscriptionsQuery = options => {
  const $ = _c(4);
  const {
    user
  } = useUserSession();
  let t0;
  let t1;
  if ($[0] !== options || $[1] !== user) {
    const customerUuid = getCustomerUuid(user);
    t0 = useQuery;
    t1 = autoshipSubscriptionsQueryFactory(customerUuid, options);
    $[0] = options;
    $[1] = user;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  return t0(t1);
};
export const useInvalidateAutoshipSubscriptions = () => {
  const $ = _c(2);
  const queryClient = useQueryClient();
  let t0;
  if ($[0] !== queryClient) {
    t0 = () => queryClient.invalidateQueries({
      queryKey: [QUERY_KEY]
    });
    $[0] = queryClient;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};